import React from "react";

import { t } from "app/utils";
import eventTypes from "constants/eventTypes";

import QueryStringList, { QueryStringListState } from "components/filters/QueryStringList";

const queryKey = "t";
const options = eventTypes.reduce(
  (accum, eventType) => ({ ...accum, [eventType.value]: eventType.label }), {}
);

const EventTypeFilter = () => (
  <QueryStringList
    clearLabel={t("All Events")}
    options={options}
    queryKey={queryKey}
    title={t("Event Type")}
  />
);

export const EventTypeFilterState = () => (
  <QueryStringListState options={options} queryKey={queryKey} />
);

export default EventTypeFilter;
